export const easeTransition = {
  duration: 0.5,
  // ease: [0.0, 0.005, 0.2, 1.0],
  ease: [0.25, 0.1, 0.25, 1],
};

export const imageTransition = {
  duration: 0.5,
  delay: 0.35,
};

export const scaleAnimations = {
  initial: { opacity: 0, scaleY: 0, originY: 'top' },
  animate: { opacity: 1, scaleY: 1, originY: 'top' },
  exit: { opacity: 0, scaleY: 0, originY: 'top' },
};

export const hoverMotion = {
  rest: { scale: 1 },
  hover: { scale: 0.95 },
  tap: { scale: 1.0125 },
};

export const opacityMotion = {
  rest: { opacity: 0 },
  hover: {
    opacity: 1,
    transition: {
      ...easeTransition,
    },
  },
};

export const containerAnimations = {
  initial: { opacity: 0, x: '100%' },
  animate: { opacity: 1, x: '0%' },
  exit: { opacity: 0, x: '-100%' },
};
